import { useCardTracking } from '@aviv-classified-card/card/full';
import { useThorEvent } from '@aviv-dxp/react-thor';
import { infosEstateType, infosSerpPageView } from '../../tracking/helpers';
export var CardListName;
(function (CardListName) {
    CardListName["SERP"] = "classified_search_results";
    CardListName["MAP"] = "classified_search_results_map";
    CardListName["SIDE_MAP"] = "classified_search_results_map_list";
})(CardListName || (CardListName = {}));
export var SerpView;
(function (SerpView) {
    SerpView["SERP"] = "list";
    SerpView["MAP"] = "map";
})(SerpView || (SerpView = {}));
export const useCardClick = ({ id, searchModel, trackingName, index, isCardXXL = false }) => {
    const [estateType] = searchModel?.estateTypes || [];
    const [distributionType] = searchModel?.distributionTypes || [];
    const tracking = useCardTracking(id, isCardXXL);
    // TODO: This could be remove until the card BFF service is returning the correct tracking values for list_name
    // Override all list_name attributes in each cards tracking to the correct value
    if (tracking)
        tracking.list_name = trackingName;
    if (index !== undefined)
        tracking.index = index;
    const thorEvent = useThorEvent({
        eventData: {
            event: 'select_item',
            av_items: [tracking],
            ...(estateType && { av_estate_type_global: infosEstateType[estateType] }),
            ...(distributionType && {
                av_distribution_type_global: infosSerpPageView[distributionType].distributionTypeGlobal,
            }),
            av_initiative: 'wl_serp',
        },
    });
    return () => {
        thorEvent();
    };
};
